import type { BariPostDietitianReportData } from '@common/validation/customControls/bariPost/bariPostDietitianReport/v1/bariPostDietitianReportSchemaV1';

export const initialData: BariPostDietitianReportData = {
    assets: [],
    hulpvraag: null,
    interventie: null,
    reden_doorverwijzing: null,
    type_behandelaar: null,
    type_behandelaar_overig: null,
    vermoedelijke_diagnose: null,
    verslag: null,
    vervolgstap: null,
};
